import {RefObject, useCallback, useEffect} from 'react';

export type Handler = (event: TouchEvent | MouseEvent) => void;

export type Options = {
  enabled?: boolean;
  preventOn?: RefObject<HTMLElement>;
};

function useOnClickOutside<Container extends Element>(
  container: Container | null,
  handler: Handler,
  {enabled = true, preventOn}: Options = {},
) {
  const listener: Handler = useCallback(
    event => {
      if (!enabled) return;
      if (!container || !event.target) return;
      if (!(event.target instanceof Node)) return;
      if (container.contains(event.target)) return;
      if (preventOn?.current?.contains(event.target)) return;

      handler(event);
    },
    [container, enabled, handler, preventOn],
  );

  useEffect(() => {
    document.addEventListener('mouseup', listener);
    document.addEventListener('touchend', listener);

    return () => {
      document.removeEventListener('mouseup', listener);
      document.removeEventListener('touchend', listener);
    };
  }, [listener]);
}

export default useOnClickOutside;
